export const iconMapping = {
  BAUARBEITEN: "construction",
  BUSERSATZ: "warning",
  DEVIATION: "disruption",
  DEVIATION_STOPS: "disruption",
  DISRUPTION: "disruption",
  DISRUPTION_RAIL_REPLACEMENT: "sev",
  EINSCHRAENKUNG: "warning",
  FAHRPLAN: "warning",
  VERSPAETUNG: "warning",
};

const getIconNameFromNotification = (featureOrNotif) => {
  let properties = featureOrNotif;
  if (featureOrNotif.getProperties) {
    properties = featureOrNotif.getProperties();
  } else if (featureOrNotif.properties) {
    properties = featureOrNotif.properties;
  }
  const { category, disruption_type: disruptionType, reasons } = properties;
  let categ = category || disruptionType;
  if (reasons) {
    try {
      const isConstruction = JSON.parse(reasons).some(
        (reason) => reason === "CONSTRUCTION",
      );
      if (isConstruction) {
        categ = "BAUARBEITEN";
      }
    } catch (err) {
      console.log("Error parsing reasons: ", err);
    }
  }

  const icon = iconMapping[categ] || "disruption";
  return icon;
};

export default getIconNameFromNotification;
